import { TimePicker } from "@mui/x-date-pickers";
import { format, parse } from "date-fns";

interface InterviewTimePickerFieldProps {
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  label?: string;
}

export function InterviewTimePickerField(props: InterviewTimePickerFieldProps) {
  const { value, onChange, error, label } = props;
  const timeValue = parse(value, "HH:mm", new Date());

  return (
    <TimePicker
      skipDisabled
      ampm
      label={label}
      value={timeValue}
      slotProps={{
        textField: {
          size: "small",
          sx: {
            width: "135px",
            "& .MuiOutlinedInput-root": {
              borderRadius: 1.5,
            },
          },
          error,
        },
      }}
      minutesStep={15}
      onChange={(newValue) => {
        if (newValue) {
          onChange(format(newValue, "HH:mm"));
        }
      }}
    />
  );
}
